export enum StatusEventSignalValueParsingType {
  BIT = 'BIT',
  VALUE = 'VALUE'
}